import { render, staticRenderFns } from "./JoinEventNew.vue?vue&type=template&id=93c7e8fe&scoped=true&"
import script from "./JoinEventNew.vue?vue&type=script&lang=js&"
export * from "./JoinEventNew.vue?vue&type=script&lang=js&"
import style0 from "./JoinEventNew.vue?vue&type=style&index=0&id=93c7e8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c7e8fe",
  null
  
)

export default component.exports